import { css, type SerializedStyles } from "@emotion/react";
import type { ElementType } from "react";

import type { TextVariant } from "./types";

export const VARIANTS_TAG: Record<TextVariant, ElementType> = {
    heading: "h1",
    subheading: "h2",
    heading3: "h3",
    body: "p",
    minor: "p",
};

export const VARIANTS_STYLES: Record<TextVariant, SerializedStyles> = {
    heading: css({
        fontSize: "var(--rs-font-size-headline-3)",
        lineHeight: "var(--rs-line-height-headline-3)",
        letterSpacing: "var(--rs-letter-spacing-headline-3)",
        fontWeight: "var(--rs-font-weight-headline-3)",
        fontFamily: "var(--rs-font-family-headline-3)",
    }),
    subheading: css({
        fontSize: "var(--rs-font-size-featured-4)",
        lineHeight: "var(--rs-line-height-featured-4)",
        letterSpacing: "var(--rs-letter-spacing-featured-4)",
        fontWeight: "var(--rs-font-weight-featured-4)",
        fontFamily: "var(--rs-font-family-featured-4)",
    }),
    heading3: css({
        fontSize: "var(--rs-font-size-body-1)",
        lineHeight: "var(--rs-line-height-body-1)",
        letterSpacing: "var(--rs-letter-spacing-body-1)",
        fontWeight: "var(--rs-font-weight-featured-4)",
        fontFamily: "var(--rs-font-family-featured-4)",
    }),
    body: css({
        fontSize: "var(--rs-font-size-body-1)",
        lineHeight: "var(--rs-line-height-body-1)",
        letterSpacing: "var(--rs-letter-spacing-body-1)",
        fontWeight: "var(--rs-font-weight-body-1)",
        fontFamily: "var(--rs-font-family-body-1)",
    }),
    minor: css({
        fontSize: "var(--rs-font-size-body-2)",
        lineHeight: "var(--rs-line-height-body-2)",
        letterSpacing: "var(--rs-letter-spacing-body-2)",
        fontWeight: "var(--rs-font-weight-body-2)",
        fontFamily: "var(--rs-font-family-body-2)",
    }),
};
